import React from 'react';
import {useSelector} from "react-redux";
import ContentViewComponent from "../../../Component/ContentViewComponent";
import TableComponent from "../../../Component/TableComponent";
import ApiHandler from "../../../Handler/ApiHandler";
import {hasRight} from "../../../Common/UserCommon";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip} from "@mui/material";
import {DoneAll, Edit, RotateLeft} from "@mui/icons-material";
import ButtonComponent from "../../../Component/ButtonComponent";
import {initFormHandler} from "../../../Handler/FormHandler";
import {LinearProgressMainLayoutActivate, LinearProgressMainLayoutDeactivate} from "../../../Action/LinearProgressMainLayoutAction";
import {SnackbarOpen} from "../../../Action/SnackbarAction";
import TextFieldComponent from "../../../Component/TextFieldComponent";
import {dispatch} from "../../../App";
import {TableReload} from "../../../Action/TableAction";
import SelectComponent from '../../../Component/SelectComponent';

function SettingSubfamilyList() {
    const authenticationReducer = useSelector(state => state.AuthenticationReducer);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [openDialog, setOpenDialog] = React.useState(false);
    const [subfamily, setSubfamily] = React.useState(null);
    const [optionFamily, setOptionFamily] = React.useState([]);
    const [isUpdateSylius, setIsUpdateSylius] = React.useState(true);
    const [isLoadingSylius, setIsLoadingSylius] = React.useState(true);

    // Sylius
    const updateSylius = () => {
        setIsLoadingSylius(true);
        ApiHandler.get({
            route: 'api_setting_subfamily_sylius'
        }, (response) => {
            if (response.status === 200) {
                setIsUpdateSylius(response.data.isUpdate);
            }
            else {
                dispatch(
                    SnackbarOpen({
                        text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                        variant: 'error',
                    })
                );
                setIsUpdateSylius(false);
            }

            setIsLoadingSylius(false);
        });
    };
    React.useEffect(updateSylius, []);

    // Global
    const columns = [
        {
            name: "id",
            label: "Référence",
            options: {filter: true, sort: true}
        },
        {
            name: "label",
            label: "Libellé",
            options: {filter: true, sort: true}
        },
        {
            name: "familyText",
            label: "Famille",
            options: {filter: true, sort: true}
        },
        {
            name: "action",
            label: "Action",
            options: {filter: false, sort: false}
        }
    ];
    const getAction = (row) => {
        if ((hasRight(authenticationReducer, 'ROLE_SETTING_SUBFAMILY') || hasRight(authenticationReducer, 'ROLE_SETTING_SUBFAMILY_EDIT'))) {
            return (
                <>
                    <Tooltip title={'Modifier'} placement="left">
                        <IconButton
                            onClick={() => {
                                handlerForm.reset();
                                setSubfamily(row.id);
                                handlerForm.setValue('label', row.label);
                                handlerForm.setValue('family', row.family);
                                setOpenDialog(true);
                            }}
                        ><Edit style={{color: '#17a2b8'}}/></IconButton>
                    </Tooltip>
                </>
            );
        }
        else {
            return (
                <>
                    <IconButton style={{cursor: 'no-drop'}}>
                        <Edit/>
                    </IconButton>
                </>
            );
        }
    };

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Liste des sous-familles',
            context: 'Paramétrage',
            description: '',
            links: []
        });

        // Get family option
        ApiHandler.get({route: 'api_select_family'}, (response) => { setOptionFamily(response.data)});
    }, []);

    // Form
    const [form, setForm] = React.useState({
        label: {
            name: 'label',
            label: 'Libellé',
            textHelper: 'Saisissez le libellé de la sous-famille.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        family: {
            name: 'family',
            label: 'Famille',
            textHelper: 'Choisissez la famille de la sous-famille.',
            type: 'integer',
            defaultValue: '',
            options: {validation: ['required']}
        }
    });
    const [isLoadingForm, setIsLoadingForm] = React.useState(false);
    const handlerForm = initFormHandler(form, setForm);
    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            setIsLoadingForm(true);
            dispatch(LinearProgressMainLayoutActivate());

            if (subfamily) {
                ApiHandler.post({
                    route: 'api_setting_subfamily_edit',
                    data: handlerForm.getData(),
                    params: {id: subfamily}
                }, (response) => {
                    if (response.status === 200) {
                        setOpenDialog(false);
                        dispatch(TableReload('api_setting_subfamily_list'));
                        setSubfamily(null);
                        dispatch(
                            SnackbarOpen({
                                text: 'Sous-famille modifié avec succès.',
                                variant: 'success',
                            })
                        );

                        ApiHandler.clearCache('api_select_subfamily');
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }

                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
            else {
                ApiHandler.post({
                    route: 'api_setting_subfamily_add',
                    data: handlerForm.getData()
                }, (response) => {
                    if (response.status === 200) {
                        setOpenDialog(false);
                        dispatch(TableReload('api_setting_subfamily_list'));
                        dispatch(
                            SnackbarOpen({
                                text: 'Sous-famille créé avec succès.',
                                variant: 'success',
                            })
                        );

                        ApiHandler.clearCache('api_select_subfamily');
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }

                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
        }
    };
    React.useEffect(handlerForm.start, []);

    return (
        <ContentViewComponent loading={false} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'api_setting_subfamily_list'}
                title={'Sous-familles'}
                columns={columns}
                actionFirst={
                    (hasRight(authenticationReducer, 'ROLE_SETTING_SUBFAMILY') || hasRight(authenticationReducer, 'ROLE_SETTING_SUBFAMILY_ADD')) ?
                        {
                            label: 'Ajouter une sous-famille', onClick: () => {
                                setSubfamily(null);
                                handlerForm.reset();
                                setOpenDialog(true);
                            }
                        } : false
                }
                actionSecond={
                    (hasRight(authenticationReducer, 'ROLE_SETTING_SUBFAMILY') || hasRight(authenticationReducer, 'ROLE_SETTING_SUBFAMILY_LIST')) ?
                        {
                            label: isUpdateSylius ? <span>Sylius est à jour <DoneAll style={{verticalAlign: 'top'}}/></span> : <span>Mettre à jour Sylius <RotateLeft style={{verticalAlign: 'top'}}/></span>,
                            color: isUpdateSylius ? '#006500' : '#ffc107',
                            loading: isLoadingSylius,
                            outlined: true,
                            onClick: isUpdateSylius ? () => {
                            } : updateSylius
                        } : false
                }
                promiseData={(resolve) => {
                    ApiHandler.get({route: 'api_setting_subfamily_list'},
                        (response) => {
                            let data = response.data;
                            for (let index in data) {
                                data[index].action = getAction(data[index]);
                            }
                            resolve(data);
                        });
                }}
            />

            <Dialog open={openDialog} maxWidth={'xl'} onClose={() => setOpenDialog(false)}>
                <DialogTitle style={{fontSize: 15}}>{subfamily ? 'Modifier une sous-famille' : 'Ajouter une sous-famille'}</DialogTitle>
                <DialogContent style={{minWidth: '30vw'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextFieldComponent id={'label'} handler={handlerForm}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SelectComponent id={'family'} options={optionFamily} handler={handlerForm}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent color={'#5E6E82'} label={'Annuler'} onClick={() => setOpenDialog(false)} disabled={isLoadingForm}/>
                    <ButtonComponent label={'Enregistrer'} onClick={save} loading={isLoadingForm}/>
                </DialogActions>
            </Dialog>
        </ContentViewComponent>
    );
}

export default SettingSubfamilyList;
